import { defaultIconSize, FlexColumn, FlexRow, InlineBanner, useTranslate } from '@synqo/frontend-component-library';
import { IconInfoCircle } from '@tabler/icons-react';
import styles from './ContainerActions.module.css';
import { type ContainerCorrection } from './containerCorrections';

interface ContainerCorrectionBoxProps {
    corrections: readonly ContainerCorrection[];
}

/**
 * Lists what the correction changes about the booked containers, one line per change. Shown only when
 * something changed.
 */
// @ai-generated 2026-10-19T08:21:57+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5
export function ContainerCorrectionBox({ corrections }: ContainerCorrectionBoxProps) {
    const i18n = useTranslate('');

    if (corrections.length === 0) {
        return undefined;
    }

    const lines = (
        <FlexColumn gap="xxs" align="stretch">
            {corrections.map((correction) => (
                <FlexRow
                    key={`${correction.subject}|${correction.change}|${correction.effect}`}
                    gap="md"
                    align="baseline"
                    wrap="wrap"
                >
                    <FlexRow className={styles.correctionCell}>{correction.subject}</FlexRow>
                    <FlexRow className={styles.correctionCell}>{correction.change}</FlexRow>
                    <FlexRow className={styles.correctionEffect}>{correction.effect}</FlexRow>
                </FlexRow>
            ))}
        </FlexColumn>
    );

    return (
        <InlineBanner
            variant="info"
            size="md"
            icon={<IconInfoCircle size={defaultIconSize} />}
            title={i18n('Korrektur · wird mit Speichern gebucht')}
            description={lines}
        />
    );
}
